import { useState, useEffect, useCallback } from "react";
import { useToast } from "@pps/ui/hooks/use-toast";

interface NetworkStatus {
  isOnline: boolean;
  wasOffline: boolean;
  lastOnlineAt: Date | null;
}

export function useNetworkStatus() {
  const [status, setStatus] = useState<NetworkStatus>({
    isOnline: typeof navigator !== "undefined" ? navigator.onLine : true,
    wasOffline: false,
    lastOnlineAt: null,
  });
  const { toast } = useToast();

  const handleOnline = useCallback(() => {
    setStatus((prev) => {
      if (prev.wasOffline) {
        toast({ title: "Conexão restaurada", description: "Você está online novamente. Sincronizando dados..." });
      }
      return { isOnline: true, wasOffline: prev.wasOffline, lastOnlineAt: new Date() };
    });
  }, [toast]);

  const handleOffline = useCallback(() => {
    setStatus((prev) => ({ ...prev, isOnline: false, wasOffline: true }));
    toast({ title: "Sem conexão", description: "Algumas funcionalidades podem estar limitadas.", variant: "destructive" });
  }, [toast]);

  useEffect(() => {
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [handleOnline, handleOffline]);

  return status;
}